export const getUntagConfirmationDescription = (
  selectedLedgerIds: number[],
  selectedDEIds: number[],
): string => {
  return `You are about to submit changes to ${
    selectedLedgerIds.length && selectedDEIds.length
      ? `${selectedDEIds.length} ${pluralize(
          selectedDEIds.length,
          'transaction',
          'transactions',
        )} and all transactions in ${selectedLedgerIds.length} ${pluralize(
          selectedLedgerIds.length,
          'ledger',
          'ledgers',
        )}`
      : selectedDEIds.length
      ? `${selectedDEIds.length} ${pluralize(selectedDEIds.length, 'transaction', 'transactions')}`
      : `all transaction in ${selectedLedgerIds.length} ${pluralize(
          selectedLedgerIds.length,
          'ledger',
          'ledgers',
        )}`
  }. These will be removed from the 1099 report. Is this what you intended to do?`;
};

export const getBulkEditConfirmationDescription = (
  selectedLedgerIds: number[],
  selectedDEIds: number[],
  isTagging1099: boolean,
): string => {
  return `You are about to apply bulk edit to ${
    selectedLedgerIds.length && selectedDEIds.length
      ? `${selectedDEIds.length} ${pluralize(
          selectedDEIds.length,
          'entry',
          'entries',
        )} and all entries in ${selectedLedgerIds.length} ${pluralize(
          selectedLedgerIds.length,
          'ledger',
          'ledgers',
        )}`
      : selectedDEIds.length
      ? `${selectedDEIds.length} ${pluralize(selectedDEIds.length, 'entry', 'entries')}`
      : `all entries in ${selectedLedgerIds.length} ${pluralize(
          selectedLedgerIds.length,
          'ledger',
          'ledgers',
        )}`
  }. ${
    isTagging1099 ? '1099 changes will be visible for your client.' : ''
  } Are you sure you want to proceed?`;
};

export const pluralize = (count: number, singular: string, plural: string): string => {
  return count === 1 ? singular : plural;
};

export const getLedgerOrEntriesMessage = (
  selectedDataEntriesCount: number,
  selectedLedgersCount: number,
  deselectedDataEntriesCount: number,
  singularMessage: string,
  pluralMessage: string = singularMessage,
): string => {
  const isEntrySelected = selectedDataEntriesCount > 0;
  const isLedgerSelected = selectedLedgersCount > 0;
  const areEntriesDeselected = deselectedDataEntriesCount > 0;
  const pluralEntityName = isEntrySelected ? 'entries' : 'ledgers';
  const singularEntityName = isEntrySelected ? 'entry' : 'ledger';

  const count = isEntrySelected ? selectedDataEntriesCount : selectedLedgersCount;
  const entriesDeselectedMessage = areEntriesDeselected
    ? `, with ${deselectedDataEntriesCount} ${pluralize(
        deselectedDataEntriesCount,
        'entry',
        'entries',
      )} deselected, `
    : '';

  if (isEntrySelected && isLedgerSelected) {
    return `${selectedDataEntriesCount} ${pluralize(
      selectedDataEntriesCount,
      'entry',
      'entries',
    )} and all entries in ${selectedLedgersCount} ${pluralize(
      selectedLedgersCount,
      'ledger',
      'ledgers',
    )}${entriesDeselectedMessage} ${pluralMessage}`;
  }

  return `${count} ${pluralize(
    count,
    singularEntityName,
    pluralEntityName,
  )}${entriesDeselectedMessage} ${count === 1 ? singularMessage : pluralMessage}`;
};
